<template>
  <transition name="fade">
            <div class="videoBox" v-if="playVideo">
				<div class="box">
					<div class="videoBg"></div>
					<div class="video">
                  <video :src="videoUrl" controls="controls" id="movie"></video>
						<button class="close" @click.stop="playVideo=false"></button>
					</div>
				</div>
            </div>
   </transition>
</template>
<style lang="less" scoped>
	@red: #e60012;
   .videoBox {
		position: fixed;
		width: 100%;
		height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
		left: 0;
		top: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 102;
		will-change: opacity;

		.box {
			position: relative;
			width: 1200px;
			height: 540px;
		}
        .videoBg {
			position: absolute;
			top: 23px;
            width:1200px;
            height:500px;
            z-index: 101;
            background-color: @red;
        }

        .video {
			position: absolute;
			left: 20px;
		    width: 1160px;
		    height: 540px;
            background-color: #000000;
            padding: 26px 20px;
		    border: none;
            overflow: hidden;
            z-index: 102;

            video {
                width: 1072px;
                height: 480px;
            }

		    .close {
			    border: none;
		    	width: 17px;
		    	height: 17px;
		    	position: absolute;
		    	right: 22px;
		    	top: 22px;
		    	background: transparent url(../assets/images/index/close.png) center/auto no-repeat;
		    }

        }
    }
</style>
<script>
   export default {
      props: {
         videoUrl: {
            default: "",
            type:String
         }
      },
      data(){
         return {
            playVideo:false
         }
      },
      computed: {

      },
      methods: {
         played(){
            this.playVideo=true;
            this.$nextTick(()=>{
               $('#movie').get(0).play();
            })
         }
      }
   }
</script>